"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogBody = exports.getBodyPaddingStyle = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var DialogWidget_1 = require("./DialogWidget");
var BodyStyles = {
    boxSizing: 'border-box',
    flexGrow: 1,
    outline: 'none',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
};
function getBodyPaddingStyle(type, showFooter) {
    var style = {
        paddingTop: 0,
        paddingRight: TabStyles_1.TabStyles.Spacing.LargeSpace,
        paddingBottom: TabStyles_1.TabStyles.Spacing.LargeSpace,
        paddingLeft: TabStyles_1.TabStyles.Spacing.LargeSpace
    };
    switch (type) {
        case DialogWidget_1.DialogType.NormalWithTitleBar:
            style.paddingTop = TabStyles_1.TabStyles.Spacing.LargeSpace;
            break;
        case DialogWidget_1.DialogType.LightweightTitleBar:
            style.paddingLeft = TabStyles_1.TabStyles.Spacing.ExtraLargeSpace - TabStyles_1.TabStyles.Sizing.BorderWidth;
            style.paddingRight = style.paddingLeft;
            break;
        case DialogWidget_1.DialogType.Uber:
            style.paddingTop = TabStyles_1.TabStyles.Spacing.MediumSpace;
            break;
        default:
            break;
    }
    if (showFooter) {
        style.paddingBottom = 0;
    }
    return style;
}
exports.getBodyPaddingStyle = getBodyPaddingStyle;
exports.DialogBody = function (props) {
    return React.createElement("div", { children: props.children, "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'Body'), id: Declarative_1.makeTestId(props.testId, 'Body-Id'), style: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, BodyStyles), getBodyPaddingStyle(props.type, props.showFooter)), props.dialogBodyStyle) });
};
exports.DialogBody.displayName = 'DialogBody';
//# sourceMappingURL=DialogBody.js.map